<div class="row">
    <div class="col-3">
        <img class="image-icon-sm" src="content/images/measurements.svg" />
        <span class="d-inline-flex p-2 h5 fw-bold">{{ 'study-editor.summary-results.title' | translate}}</span>
    </div>
    <div class="col-9 d-flex justify-content-end align-items-center">
        <div ngbDropdown container="body" class="d-inline-block ps-2" placement="bottom-right">
            <button class="btn btn-sm btn-info" id="columnsDropdown" ngbDropdownToggle>
                <span>{{ 'study-editor.summary-results.actions' | translate}}</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="columnsDropdown">
                @if (principal.hasAnyAuthorityDirect(EXPORT_SSA_RESULTS_PERMISSIONS)) {
                    <button ngbDropdownItem type="button" class="dropdown-item" (click)="exportSSAResults()">
                        <i class="fa fa-download"></i><span class="ms-1">{{ 'study-editor.summary-results.action.export-summary-and-means-dataset' | translate}} </span>
                    </button>
                }
                @if (principal.hasAnyAuthorityDirect(DELETE_SSA_RESULTS_PERMISSIONS)) {
                    <button ngbDropdownItem type="button" class="dropdown-item text-danger" (click)="deleteSSAResults()">
                        <i class="fa fa-trash"></i><span class="ms-1">{{ 'study-editor.summary-results.action.delete-summary-and-means-dataset' | translate}} </span>
                    </button>
                }
            </div>
        </div>
    </div>
</div>
@if (principal.hasAnyAuthorityDirect(SSA_SUMMARY_STATISTICS_PERMISSIONS) || principal.hasAnyAuthorityDirect(SSA_MEANS_BLUE_PERMISSIONS)) {
    <div class="row pt-3">
        <div class="col-lg-12">
            <section>
                <nav>
                    <ul class="nav nav-tabs">
                        <li *ngIf="principal.hasAnyAuthorityDirect(SSA_SUMMARY_STATISTICS_PERMISSIONS)" class="nav-item pe-1" >
                            <a class="nav-link p-2" [ngClass]="{active: summaryStatisticsDataset?.datasetId === currentDataset?.datasetId}" [class.disabled]="isLoading"
                               (click)="viewDataset(summaryStatisticsDataset)">{{ 'study-editor.summary-results.tabs.summary-statistics' | translate }}</a>
                        </li>
                        <li *ngIf="principal.hasAnyAuthorityDirect(SSA_MEANS_BLUE_PERMISSIONS)" class="nav-item pe-1" >
                            <a class="nav-link p-2" [ngClass]="{active: meansDataset?.datasetId === currentDataset?.datasetId}" [class.disabled]="isLoading"
                               (click)="viewDataset(meansDataset)">{{ 'study-editor.summary-results.tabs.means-blues' | translate }}</a>
                        </li>
                    </ul>
                </nav>
                <div class="tab-content p-3">
                    <jhi-summary-dataset [currentDataset]="currentDataset" [(isLoading)]="isLoading"></jhi-summary-dataset>
                </div>
            </section>
        </div>
    </div>
}

